export default __webpack_public_path__ + "static/media/tutorial1.6eacebe2.png";